import LayoutPadrao from 'lg-vue-components/layoutPadrao'
export default [
   {
      path: '/',
      redirect: 'funcionario',
      component: LayoutPadrao,
      children: [
         {
            path: '/funcionario',
            name: 'funcionario',
            component: () => import('../pages/ListarPerfilFrequencia.vue')
         }
      ]
   },
   {
      path: '/',
      redirect: 'funcionario',
      component: LayoutPadrao,
      children: [
         {
            path: '/funcionario/:id',
            name: 'funcionario-editar',
            component: () => import('../pages/EditarPerfilFrequencia.vue')
         }
      ]
   }
]
